import { Box, Skeleton } from '@chakra-ui/react';

import { MultiValue } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import React from 'react';
import { useQuery } from '@apollo/client';
import { JobSeeker } from '~/generated';
import { myProfile } from '~/queries';

type Option = { label: string; value: string };

const CertificationsSelect: React.FC<{
  onChange: (value: string[]) => void;
}> = ({ onChange }) => {
  const { data, loading } = useQuery<{ jobSeekerMe: JobSeeker }>(myProfile);
  const defaultValue = () => {
    if (!loading) {
      return (data?.jobSeekerMe?.certifications?.filter(Boolean) || []).map(
        (label) => ({
          label,
          value: label,
        }),
      );
    }

    return [];
  };
  const handleChange = (newValue: MultiValue<Option>) => {
    const certifications = newValue.map((detail) => detail.label);
    onChange(certifications);
  };

  return loading ? (
    <Skeleton height="20px" />
  ) : (
    <Box
      maxW="600px"
      w="full"
      rounded="md"
      overflow="hidden"
      borderStyle="solid"
    >
      <CreatableSelect
        isClearable
        isMulti
        onChange={handleChange}
        placeholder="例: 普通自動車免許 日商簿記2級 英検2級"
        defaultValue={defaultValue()}
        formatCreateLabel={(newLabel: string) => `${newLabel}を追加する`}
        noOptionsMessage={() => '選択肢がありません'}
      />
    </Box>
  );
};

export default CertificationsSelect;
